(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/result.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/result.js');
"use strict";

const {
  useDrawResults
} = svs.components.tipsen.hooks;
const {
  selectSportEvent
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  useSelector
} = ReactRedux;
const {
  getIsCancelled,
  getIsOngoing,
  getIsFinished,
  getIsPostponedOrDelayed
} = svs.components.sportinfo.common.matchState;
const {
  useMemo
} = React;
const {
  MatchResultTypes
} = svs.components.sport.tipsenShared.constants;
const Result = _ref => {
  let {
    drawEvent,
    drawNumber,
    productId
  } = _ref;
  const {
    data
  } = useDrawResults({
    productId,
    drawNumber
  });
  const [currentDrawResult] = data;
  const eventNumber = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventNumber) || undefined;
  const currentMatchId = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.matchId) || undefined;
  const sportEvent = useSelector(state => selectSportEvent(state, currentMatchId));
  const isFinished = currentDrawResult ? currentDrawResult[eventNumber - 1].matchResultState >= MatchResultTypes.VERIFIED : false;
  const isOngoing = !isFinished && sportEvent ? getIsOngoing(sportEvent.sportEventStatus) || getIsFinished(sportEvent.sportEventStatus) : undefined;
  const isDelayed = !isFinished && sportEvent ? getIsPostponedOrDelayed(sportEvent.sportEventStatus) : undefined;
  const isCancelledBySportEvent = sportEvent ? getIsCancelled(sportEvent.sportEventStatus) : undefined;
  const result = useMemo(() => {
    if (currentDrawResult && (isOngoing || isFinished) && !isDelayed) {
      const resultForCurrentEvent = currentDrawResult[eventNumber - 1];
      const isCancelledByDrawResult = resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.cancelled;
      let formattedResult = resultForCurrentEvent ? "".concat(resultForCurrentEvent.home, " - ").concat(resultForCurrentEvent.away) : '';
      formattedResult = isCancelledBySportEvent || isCancelledByDrawResult ? '-' : formattedResult;
      return formattedResult;
    }
    return undefined;
  }, [currentDrawResult, eventNumber, isCancelledBySportEvent, isDelayed, isFinished, isOngoing]);
  if (!result) {
    return null;
  }
  return React.createElement("div", {
    className: "pg_coupon_static__init__result"
  }, result);
};
setGlobal('svs.components.tipsen.couponStatic.Result', Result);

 })(window);